export default "__VITE_ASSET__BBVnsc9v__"